const messages = {
  subtitle: "Upoznajte naš Bridgestone tim",
  title: "Kontakt servis",
  description: "Dobrodošli u kontakt servis",
  teams: {
    direct: "Direktno",
    indirect: "Indirektno",
    tyre: "Tim trgovine gumama",
    car: "Tim autokuća",
    lkw: "Tim kamiona",
    em_otr: "Tim EM/OTR",
    farm_tractor: "Tim poljoprivrednih traktora",
    bandag: "Tim Bandag",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
